const APP_ENV = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;
const AUTH_SERVICE = import.meta.env.VITE_AUTH_SERVICE || 'cognito';
const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8080';
const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM || 'master';
const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'nest-cedi';
const COGNITO_URL = import.meta.env.VITE_COGNITO_URL || 'https://agenti.cedispa.it';

export const getBaseUrl = () => {
  const base = APP_ENV === 'production' ? 'https://agenti.cedispa.it' :
               APP_ENV === 'preview' ? 'http://localhost:4173' :
               'http://localhost:5173';
  return base.replace(/\/$/, ''); // Rimuove trailing slash
};

export const getAuthUrl = (currentPath?: string) => {
  const baseUrl = getBaseUrl();
  
  // Rimuovi qualsiasi parametro di query esistente dall'URL corrente
  const cleanCurrentPath = currentPath?.split('?')[0] || '';
  
  // Rimuovi eventuali URL completi incorporati
  const finalPath = cleanCurrentPath
    .replace(/^https?:\/\/[^/]+/, '')  // Rimuove protocolli e domini
    .replace(/^\/+/, '')               // Rimuove leading slashes
    .replace(/\/+$/, '');              // Rimuove trailing slashes

  // Se il path contiene ancora http o https, usa solo /login
  const redirectPath = finalPath.includes('http') ? '/login' : 
                      finalPath && !finalPath.includes('/auth/') ? `/${finalPath}` : 
                      '/login';

  const redirectUri = `${baseUrl}${redirectPath}`;

  if (AUTH_SERVICE === 'keycloak') {
    const authUrl = new URL(`${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/auth`);
    authUrl.searchParams.set('client_id', KEYCLOAK_CLIENT_ID);
    authUrl.searchParams.set('response_type', 'code');
    authUrl.searchParams.set('scope', 'openid profile email');
    authUrl.searchParams.set('redirect_uri', redirectUri);
    return authUrl.toString();
  } else {
    return `${COGNITO_URL}/login?response_type=code&client_id=6v14r17261ef8vgkjr0dtge33f&redirect_uri=${encodeURIComponent(redirectUri)}`;
  }
};

export const getLogoutUrl = () => {
  const baseUrl = getBaseUrl();
  const redirectUri = `${baseUrl}/login`;

  if (AUTH_SERVICE === 'keycloak') {
    const logoutUrl = new URL(`${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/logout`);
    logoutUrl.searchParams.set('client_id', KEYCLOAK_CLIENT_ID);
    logoutUrl.searchParams.set('post_logout_redirect_uri', redirectUri);
    return logoutUrl.toString();
  } else {
    return `${COGNITO_URL}/logout?client_id=6v14r17261ef8vgkjr0dtge33f&logout_uri=${encodeURIComponent(redirectUri)}`;
  }
};
